/**
 * Shared between the consumer ordering app and the back office, which is why it
 * sits here rather than in either one. Both render this value and the admin
 * writes it; three separate declarations of it drifted before this file.
 *
 * Mirrors `domain/Ordering/Enums/TabEntryMode.php`.
 *
 * How a diner joins a table at a venue. Distinct from `OrderMode` (dine in or
 * takeaway) and `OrderingMode` (whether the menu takes orders at all).
 *
 * Mirrors the backend `TabEntryMode`, which is what
 * `HandlePjazzaInertiaRequests` serialises onto the shared props — so the two
 * values here are the only ones a venue can carry.
 */
const ENTRY_MODE = {
  /** A waiter opens the tab and prints a one-time code; scanning it is the only way in. */
  WAITER_SESSION: 'waiter_session',
  /** No printed code — the diner names their own table, and the first round mints the session. */
  TABLE_PICKER: 'table_picker'
} as const

type EntryMode = (typeof ENTRY_MODE)[keyof typeof ENTRY_MODE]

export { ENTRY_MODE }
export type { EntryMode }
